


































































































import {
  computed,
  defineComponent,
  ref,
  getCurrentInstance,
  ComponentInternalInstance,
  toRefs,
} from '@vue/composition-api';
import { SearchIcon, CheckIcon, CloseIcon } from 'tdesign-icons-vue';
import i18n, { i18n_t } from '@/locales/i18n';
import listHandler from '@/renderer/components/dialog/selectTargetFolder/selectTargetHandler';
import createHandler from '@/renderer/components/SpacePage/compositions/createHandler';
import searchHandler from '@/renderer/views/desktop/FileManagement/Search/composition/searchHandler';
import tips from '@/renderer/scripts/utils/tips';
export default defineComponent({
  components: {
    SearchIcon,
    CheckIcon,
    CloseIcon,
  },
  props: {
    title: String,
    show: {
      required: true,
      type: Boolean,
      default: false,
    },
    spaceId: {
      type: String,
      default: '',
    },
  },
  setup(props, context) {
    // 解构 props
    const { spaceId } = toRefs(props);
    // 当前组件
    const currComponent: ComponentInternalInstance | null = getCurrentInstance();
    const vm = (currComponent as ComponentInternalInstance).proxy;
    // 额外的个人空间和企业空间
    const locationName = computed(() => {
      const { $route } = vm;
      if ($route.name === 'teamSpace') return i18n_t('企业空间');
      if ($route.name === 'personalSpace') return i18n_t('个人空间');
      if ($route.name === 'collaborationSpaceList') return i18n_t('协作空间');
      return '';
    });
    // 默认scope
    const defaultScope = computed(() => (vm.$route.query.path ? 'current' : 'all'));
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const newFolderName = ref(i18n_t('新建文件夹'));
    const newFolderShow = ref(false);
    const {
      dirData,
      dirList,
      loadMoreShow,
      curPath,
      loading: listLoading,
      methods: listMethods,
    } = listHandler(spaceId, true);
    const { methods: createMethods } = createHandler(spaceId);
    const {
      searchParams,
      isAccurateSearch,
      loading: searchLoading,
      methods: searchMethods,
      tableData: searchData,
    } = searchHandler(spaceId);
    searchParams.keyword = '';
    searchParams.scope = defaultScope.value;
    searchParams.types = ['dir'];
    const showSearchResult = ref(false); // 展示搜索结果
    const validateShow = ref(false);
    const validateTip = ref('');
    // 在非搜索时列表加载loadMore|在搜索时hasMore
    const hasMore = computed(
      () => (!showSearchResult.value && loadMoreShow.value) || (showSearchResult.value && searchData.hasMore),
    );

    const list = computed(() => {
      if (showSearchResult.value) {
        return searchData.list;
      }
      return dirList.value;
    });
    const loading = computed(() => {
      if (showSearchResult.value && searchData.list.length > 0) {
        return false;
      }
      return listLoading.value || searchLoading.value;
    });
    const crumbs = computed(() => {
      if (showSearchResult.value) {
        const c = [
          // 由于文件夹不会出现 / 命名，所以此处导航命名包含 /
          {
            name: '/return',
            content: i18n_t('返回'),
          },
          {
            name: '/result',
            content: i18n_t('搜索结果'),
          },
        ];

        return c;
      }
      const c = [i18n_t('全部'), ...dirData.crumbs];
      return c.map(p => ({
        name: p === i18n_t('全部') ? '' : p,
        content: p,
        type: 'dir',
      }));
    });
    const methods = {
      submit(hasAuth: boolean) {
        if (hasAuth) {
          context.emit('onSubmit', curPath);
        } else {
          tips.error(i18n_t('您没有操作该文件夹的权限'));
        }
      },
      createNewFolder() {
        newFolderShow.value = true;
        newFolderName.value = i18n_t('新建文件夹');
        if (currComponent) {
          const { newFolder } = currComponent.refs;
          setTimeout(() => {
            if (newFolder) {
              (newFolder as HTMLElement).focus();
            }
          }, 20);
        }
      },
      onEnter() {
        if (newFolderName.value.indexOf('/') !== -1) {
          validateShow.value = true;
          validateTip.value = i18n_t('名称不支持字符“/”');
        } else if (newFolderName.value === '') {
          validateShow.value = true;
          validateTip.value = i18n_t('名称不能为空');
        } else if (newFolderName.value.length > 200) {
          validateShow.value = true;
          validateTip.value = i18n_t('名称不能超过200个字符');
        } else {
          validateShow.value = false;
          newFolderShow.value = false;
          createMethods.onCreateFolder(newFolderName.value, dirData.crumbs);
        }
      },
      onIconClose() {
        newFolderShow.value = false;
        newFolderName.value = '';
      },
      renderFileNameEle(item: any) {
        const { name, highlight } = item;
        if (highlight?.name) {
          const highlightEle = highlight?.name.join();
          let highlightHandle!: string;
          let highlightName!: string;
          try {
            highlightHandle = decodeURIComponent(highlightEle)
              .replace(/<em>/g, '<span class="highlight">')
              .replace(/<\/em>/g, '</span>');
            highlightName = decodeURIComponent(highlightEle).replace(/<em>|<\/em>/g, '');
          } catch (error) {
            highlightHandle = highlightEle.replace(/<em>/g, '<span class="highlight">').replace(/<\/em>/g, '</span>');
            highlightName = highlightEle.replace(/<em>|<\/em>/g, '');
          }
          if (highlightName === name) {
            return highlightHandle;
          }
        }
        return name;
      },
      changeCrumbs(path: string, action: 'add' | 'remove', index?: number, item?: any) {
        if (path === '/result') return;
        newFolderShow.value = false;
        if (path === '/return') {
          showSearchResult.value = false;
        } else if (showSearchResult.value) {
          // 根据当前搜索条件进入对应的目录
          showSearchResult.value = false;
          dirData.crumbs = item.path.slice(0, -1);
          listMethods.changeCrumbs(path, action, index);
        } else {
          listMethods.changeCrumbs(path, action, index);
        }
      },
      onSearch() {
        // 弹窗处搜索为模糊搜索
        isAccurateSearch.value = false;
        showSearchResult.value = true;
        const path = searchParams.scope === 'all' ? '' : curPath.value;
        searchMethods.onSearch(path);
      },
      loadMore() {
        if (showSearchResult.value) {
          const path = searchParams.scope === 'all' ? '' : curPath.value;
          searchMethods.onSearch(path, 'scroll');
        } else {
          listMethods.loadMore();
        }
      },
    };
    return {
      innerShow,
      newFolderName,
      newFolderShow,
      dirData,
      crumbs,
      loading,
      list,
      hasMore,
      // newFolder,
      // createMethods,
      searchParams,
      searchLoading,
      showSearchResult,
      validateShow,
      validateTip,
      locationName,
      ...methods,
    };
  },
});
